// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"SW-z","sponsoredTooltipWrapper":"TW-z","sponsoredTooltip":"UW-z","newCard":"VW-z"};